(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7953],{

/***/ 5263:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/autocrew-logo.2f99ac07.png","height":55,"width":175,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAIAAAAhqtkfAAAAU0lEQVR42mP4sH3Xh/2Hvm7ZcffQ4ZU7d67esmXphg1rtm1jeL142Ye16+9t3LShsfnykmXXV6+5tmr1zXXrGe4ycN5nYDjGIHPbxvUJA8MjGAIAUIYqjwvjbb0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 4357:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/google.3b62bd6f.png","height":36,"width":119,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR4nGN0afkc9omZ+e+ijTUvFaP6GL5pJv0TPDODsYOrQj17Xt8dRreWTwavWFgF16wqYJVNmMn8QT2fUfxMl+EMhikPY9YUvwUAzrUc0fVlNLoAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 1203:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/liquimoly-logo.5ab49ef4.png","height":979,"width":1500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAqUlEQVR4nBXL3wrBUBwH8O9vlj9LtpKRG4kmNI/gWT2AQskl5UrLJWkuDC1aGxdTmnPsHHmAD43n249/j7N9y5SqmgEk4J5CtBplSlPBabE+CJ4K6jRNXK4RrHYVx3OIeqWEIHqBnNEsLWqqcvur4QCxH0ARAlwSEi4kvVdLAd2gfM1EvHFQ6HXBPA9KQYN4RKDnZJpw181lbVtmDB2SMVAuj28QENvt2Q/Sv0zzn0VGMAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 7550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _eo_locale_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7245);






var GarageListItemBrandIcons = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(GarageListItemBrandIcons, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(GarageListItemBrandIcons);
    function GarageListItemBrandIcons() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GarageListItemBrandIcons);
        return _super.apply(this, arguments);
    }
    var _proto = GarageListItemBrandIcons.prototype;
    _proto.render = function render() {
        var brands = this.props.brands;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "garageListItem__brandIcons",
            children: [
                brands.map(function(brand) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fa-kit fa-fw text-gray-700 fa-".concat(brand.icon.replace("fa-", ""), " text-2xl mr-2")
                    }, brand.id);
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "garageListItem__brandIcons__garageText",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_eo_locale_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                        id: "authorized_garage"
                    })
                })
            ]
        });
    };
    return GarageListItemBrandIcons;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
/* harmony default export */ __webpack_exports__["Z"] = (GarageListItemBrandIcons);


/***/ }),

/***/ 465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _splidejs_react_splide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7677);
/* harmony import */ var _splidejs_react_splide_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1826);
/* harmony import */ var _splidejs_react_splide_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_splidejs_react_splide_css__WEBPACK_IMPORTED_MODULE_3__);







var GarageListItemSlider = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(GarageListItemSlider, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GarageListItemSlider);
    function GarageListItemSlider() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, GarageListItemSlider);
        return _super.apply(this, arguments);
    }
    var _proto = GarageListItemSlider.prototype;
    _proto.render = function render() {
        var ref, ref1;
        var _props = this.props, images = _props.images, alt = _props.alt, id = _props.id, onClick = _props.onClick, listIndex = _props.listIndex, partner = _props.partner;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "garageListItem_slider ".concat(partner.shouldHideListImagesMobile ? "hidden md:block" : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_splidejs_react_splide__WEBPACK_IMPORTED_MODULE_2__/* .Splide */ .tv, {
                options: {
                    rewind: true,
                    height: 192,
                    breakpoints: {
                        375: {
                            height: 218
                        },
                        767: {
                            height: 275
                        }
                    },
                    lazyLoad: "sequential",
                    preloadPages: 0,
                    type: "slide",
                    perPage: 1,
                    classes: {
                        arrows: "splide__arrows hidden md:block z-10"
                    },
                    arrows: images.length > 1,
                    drag: images.length > 1
                },
                children: [
                    images.length > 0 && ((ref = images[0]) === null || ref === void 0 ? void 0 : ref.sizes) !== null && images.map(function(image, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_splidejs_react_splide__WEBPACK_IMPORTED_MODULE_2__/* .SplideSlide */ .jw, {
                            className: "rounded-md z-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                className: "rounded-md w-full h-full object-cover",
                                onClick: onClick,
                                children: [
                                    image.sizes && image.sizes.filter(function(size) {
                                        return size.name.includes("list");
                                    }).map(function(size, innerIndex) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                            media: "".concat(size.media),
                                            srcSet: "".concat("https://werkstatt.repareo.de/storage/" + size.path),
                                            width: "".concat(size.width),
                                            height: "".concat(size.height)
                                        }, id + "listSlider" + innerIndex);
                                    }),
                                    image.sizes && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "rounded-md w-full h-full object-cover",
                                        loading: listIndex && listIndex < 4 && index < 1 ? "eager" : "lazy",
                                        src: "https://werkstatt.repareo.de/storage/" + image.sizes[0].path,
                                        height: image.sizes[0].height,
                                        width: image.sizes[0].width,
                                        alt: index == 0 ? alt : ""
                                    })
                                ]
                            })
                        }, id + "listSlider" + index);
                    }),
                    images.length === 0 || ((ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.sizes) === null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_splidejs_react_splide__WEBPACK_IMPORTED_MODULE_2__/* .SplideSlide */ .jw, {
                        className: "rounded-md z-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "rounded-md w-full h-full object-cover",
                            src: "https://werkstatt.repareo.de/" + partner.fallbackImage,
                            alt: "Werkstatt",
                            onClick: onClick
                        })
                    })
                ]
            })
        });
    };
    return GarageListItemSlider;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
/* harmony default export */ __webpack_exports__["Z"] = (GarageListItemSlider);


/***/ }),

/***/ 7953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MapLocationIcon": function() { return /* binding */ MapLocationIcon; },
  "default": function() { return /* binding */ Map_GarageListMap; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(8420);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 27 modules
var format = __webpack_require__(8085);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(879);
// EXTERNAL MODULE: ./store.ts
var store = __webpack_require__(7576);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
;// CONCATENATED MODULE: ./public/assets/images/mehrmarkencenterSmall.webp
/* harmony default export */ var mehrmarkencenterSmall = ({"src":"/_next/static/media/mehrmarkencenterSmall.c5f3a6f8.webp","height":190,"width":190,"blurDataURL":"data:image/webp;base64,UklGRl4AAABXRUJQVlA4IFIAAADQAQCdASoIAAgAAkA4JbACdAEOlmUCAAD+80oe33hm11/yoaOw+Ka1/v9wnOFS6D1J+0nj+egetD5+WuwbVzf8dMf90/241+xv7XkE9HDpAAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Home/ContentElements/PartnerIcons/Mehrmarkencenter.tsx






var Mehrmarkencenter = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Mehrmarkencenter, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Mehrmarkencenter);
    function Mehrmarkencenter() {
        (0,_class_call_check/* default */.Z)(this, Mehrmarkencenter);
        return _super.apply(this, arguments);
    }
    var _proto = Mehrmarkencenter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-2 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-normal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                src: mehrmarkencenterSmall.src,
                alt: "Mehrmarkencenter",
                className: "!w-[25px]"
            })
        });
    };
    return Mehrmarkencenter;
}(react.PureComponent);

;// CONCATENATED MODULE: ./public/assets/images/bcq-small.svg
/* harmony default export */ var bcq_small = ({"src":"/_next/static/media/bcq-small.e393ef2f.svg","height":62,"width":116});
;// CONCATENATED MODULE: ./components/Home/ContentElements/PartnerIcons/BQC.tsx






var BQC = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BQC, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BQC);
    function BQC() {
        (0,_class_call_check/* default */.Z)(this, BQC);
        return _super.apply(this, arguments);
    }
    var _proto = BQC.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-2 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-normal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                src: bcq_small.src,
                alt: "BQC",
                className: "!w-[25px] inline-block align-middle mb-[2px]"
            })
        });
    };
    return BQC;
}(react.PureComponent);

// EXTERNAL MODULE: ./public/assets/images/liquimoly-logo.png
var liquimoly_logo = __webpack_require__(1203);
;// CONCATENATED MODULE: ./components/Home/ContentElements/PartnerIcons/LiquiMoly.tsx






var LiquiMoly = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LiquiMoly, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LiquiMoly);
    function LiquiMoly() {
        (0,_class_call_check/* default */.Z)(this, LiquiMoly);
        return _super.apply(this, arguments);
    }
    var _proto = LiquiMoly.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-2 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-normal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                src: liquimoly_logo/* default.src */.Z.src,
                alt: "LiquiMoly",
                className: "!w-[25px]"
            })
        });
    };
    return LiquiMoly;
}(react.PureComponent);

// EXTERNAL MODULE: ./public/assets/images/autocrew-logo.png
var autocrew_logo = __webpack_require__(5263);
;// CONCATENATED MODULE: ./components/Home/ContentElements/PartnerIcons/AutoCrew.tsx






var AutoCrew = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AutoCrew, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AutoCrew);
    function AutoCrew() {
        (0,_class_call_check/* default */.Z)(this, AutoCrew);
        return _super.apply(this, arguments);
    }
    var _proto = AutoCrew.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-2 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-normal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                src: autocrew_logo/* default.src */.Z.src,
                alt: "AutoCrew",
                className: "!w-[25px]"
            })
        });
    };
    return AutoCrew;
}(react.PureComponent);

;// CONCATENATED MODULE: ./components/GarageList/Map/GarageListMapMarker.tsx









var GarageListMapMarker = function(param) {
    var garage = param.garage, open = param.open, onClick = param.onClick, onToggle = param.onToggle, partner = param.partner;
    var highlightedGarageId = (0,store/* default */.Z)().highlightedGarageId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "garageListMapMarker transition-all duration-400",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MapMarkerIcon, {
                garageId: garage.id,
                price: garage.calculation && garage.calculation.estimated_price > 0 ? garage.calculation.estimated_price.toFixed(2).replace(".", ",").replace(",00", "") : "",
                date: garage.available_days && garage.available_days.length > 0 ? formatShortDate(garage.available_days[0].available_at) : "n/a",
                clicked: open,
                onClick: function() {
                    return onToggle(garage, true);
                },
                partner: partner,
                highlighted: garage.id == highlightedGarageId
            }),
            partner.showDateOnMapMarker && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "leaflet-popup-tip markertriangle ".concat(garage.id == highlightedGarageId ? "!bg-primary-500" : "")
            })
        ]
    });
};
var MapMarkerIcon = function(param) {
    var garageId = param.garageId, price = param.price, date = param.date, clicked = param.clicked, onClick = param.onClick, partner = param.partner, highlighted = param.highlighted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: onClick,
        className: "grid ".concat(price.length > 0 ? "grid-cols-8" : "", " ").concat(price.length == 0 && !partner.hasMapMarkerIcon ? "grid-cols-4" : "", " ").concat(partner.hasMapMarkerIcon && partner.showDateOnMapMarker ? "grid-cols-6" : "", "  ").concat(partner.hasMapMarkerIcon && !partner.showDateOnMapMarker ? "grid-cols-2" : "", "  ").concat(clicked ? "lg:invisible" : "", " ").concat(clicked || highlighted ? "bg-primary-500 text-white " : "bg-white text-gray-900", " rounded-md w-max relative right-[38%] bottom-4 z-10"),
        children: [
            partner.id == 18 && price.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mehrmarkencenter, {}),
            partner.id == 21 && price.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BQC, {}),
            partner.id == 27 && price.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(LiquiMoly, {}),
            partner.id == 29 && price.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoCrew, {}),
            price.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-4 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-semibold border-r border-gray-200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "€ ",
                        price
                    ]
                })
            }),
            partner.showDateOnMapMarker && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-4 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-normal min-w-[35px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: date
                })
            })
        ]
    });
};
var formatShortDate = function(date) {
    if (typeof date === "string") {
        date = (0,parseISO/* default */.Z)(date);
    }
    return (0,format/* default */.Z)(date, "dd.MM.", {
        locale: de/* default */.Z
    });
};

// EXTERNAL MODULE: ./node_modules/react-leaflet/lib/MapContainer.js
var MapContainer = __webpack_require__(5715);
// EXTERNAL MODULE: ./node_modules/react-leaflet/lib/TileLayer.js + 1 modules
var TileLayer = __webpack_require__(2013);
// EXTERNAL MODULE: ./node_modules/react-leaflet/lib/Marker.js
var Marker = __webpack_require__(577);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/generic.js + 5 modules
var generic = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/element.js
var lib_element = __webpack_require__(7999);
// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(5243);
var leaflet_src_default = /*#__PURE__*/__webpack_require__.n(leaflet_src);
;// CONCATENATED MODULE: ./node_modules/react-leaflet/lib/Popup.js



const Popup = (0,generic/* createOverlayComponent */.SO)(function createPopup(props, context) {
    const popup = new leaflet_src.Popup(props, context.overlayContainer);
    return (0,lib_element/* createElementObject */.O)(popup, context);
}, function usePopupLifecycle(element, context, { position  }, setOpen) {
    (0,react.useEffect)(function addPopup() {
        const { instance  } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) {
                setOpen(false);
            }
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) {
                instance.setLatLng(position);
            }
            instance.openOn(context.map);
        } else {
            // Attach to container component
            context.overlayContainer.bindPopup(instance);
        }
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            context.overlayContainer?.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});

// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(7762);
// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet.css
var leaflet = __webpack_require__(5729);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./components/GarageList/GarageListParts/GarageListItemParts/GarageListItemSlider.tsx
var GarageListItemSlider = __webpack_require__(465);
// EXTERNAL MODULE: ./components/GarageList/GarageListParts/GarageListItemParts/GarageListItemBrandIcons.tsx
var GarageListItemBrandIcons = __webpack_require__(7550);
// EXTERNAL MODULE: ./node_modules/@eo-locale/react/lib/index.js + 1 modules
var lib = __webpack_require__(7245);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./hooks/useDaysLeft.ts
var useDaysLeft = __webpack_require__(9377);
;// CONCATENATED MODULE: ./components/GarageList/Map/GarageListPopup.tsx











var GarageListPopup_formatShortDate = function(date) {
    if (typeof date === "string") {
        date = (0,parseISO/* default */.Z)(date);
    }
    return (0,format/* default */.Z)(date, "dd.MM.", {
        locale: de/* default */.Z
    });
};
var GarageListPopup = /*#__PURE__*/ react.memo(function(param) {
    var garage = param.garage, partner = param.partner;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(null), availableDay = ref4[0], setAvailableDay = ref4[1];
    var ref5 = (0,useDaysLeft/* useDaysLeft */.b)(), getDaysLeft = ref5.getDaysLeft, getFormattedText = ref5.getFormattedText;
    (0,react.useEffect)(function() {
        var listItem = document.getElementById("garageListItemCard-".concat(garage.id));
        var list = document.getElementById("garageItemList");
        if (listItem && list && window.innerWidth > 767) {
            var listItemTop = listItem.offsetTop - 250;
            list.scroll({
                top: listItemTop,
                behavior: "smooth"
            });
        }
        garage.available_days && garage.available_days.length > 0 && setAvailableDay(garage.available_days[0].available_at);
    }, [
        garage.available_days
    ]);
    var handleNavigate = function() {
        var ref, ref1;
        router.push("/".concat(partner.slug, "/").concat((ref = garage.profileSlug) === null || ref === void 0 ? void 0 : ref.split("/")[0], "/").concat(garage.id, "-").concat((ref1 = garage.profileSlug) === null || ref1 === void 0 ? void 0 : ref1.split("/")[1], "/"));
    };
    var images = [
        {
            sizes: garage.cover_image_sizes
        }
    ].concat((0,_to_consumable_array/* default */.Z)(garage.images));
    var rating = garage.rating ? (garage.rating * 0.05).toFixed(2) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 relative pb-4",
        children: [
            garage.profileSlug && availableDay && ((ref = garage.pivot) === null || ref === void 0 ? void 0 : ref.bookable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "garageListItemCard__link",
                onClick: handleNavigate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 pb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageListItemSlider/* default */.Z, {
                    images: images,
                    alt: garage.name,
                    id: garage.id,
                    partner: partner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 flex col-span-12 items-center pb-3 headlineContainer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base leading-6 font-semibold text-gray-900 flex-grow pr-2",
                        children: garage.name.length > 20 ? garage.name.substring(0, 17) + "..." : garage.name
                    }),
                    rating !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-sm leading-5 font-semibold flex-shrink-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-kit fa-star fa-fw text-yellow-500 text-regular relative inline-block mr-1"
                            }),
                            rating,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-normal",
                                children: [
                                    " (",
                                    (ref1 = garage.review_count) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            garage.garageConcept && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-full flex items-center gap-x-2 text-sm px-4 my-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        className: "h-6",
                        src: "https://werkstatt.repareo.de/storage/" + garage.garageConcept.logo,
                        alt: garage.garageConcept.name
                    }),
                    garage.garageConcept.name
                ]
            }),
            !garage.garageConcept && garage.authorizedBrands && garage.authorizedBrands.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageListItemBrandIcons/* default */.Z, {
                brands: garage.authorizedBrands
            }),
            !garage.garageConcept && garage.authorizedBrands && garage.authorizedBrands.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "garageListItemCard__right__authorizedBrands flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fa-kit fa-garage fa-fw text-gray-700 mr-2 text-xl float-left inline-block align-middle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "garageListItemCard__right__authorizedBrands__garageText",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                            id: "free_garage"
                        })
                    })
                ]
            }),
            (!availableDay || !((ref2 = garage.pivot) === null || ref2 === void 0 ? void 0 : ref2.bookable)) && partner.shouldDisplayPhoneIfUnavailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: (garage.email || garage.website) && partner.shouldDisplayHomepageAndMailIfNotBookable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center col-span-full md:mx-6 text-base leading-6 pt-4",
                        children: [
                            garage.website && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "flex-grow garageListItem__brandIcons__garageText no-underline",
                                href: "".concat(garage.website),
                                target: "_blank",
                                rel: "nofollow noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-kit fa-globe fa-fw text-base inline-block align-middle pr-3"
                                    }),
                                    " Website"
                                ]
                            }),
                            garage.email && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "flex-grow garageListItem__brandIcons__garageText no-underline",
                                href: "mailto:".concat(garage.email),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-kit fa-envelope fa-fw text-base inline-block align-middle pr-3"
                                    }),
                                    " Email"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex-grow garageListItem__brandIcons__garageText",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-kit fa-phone fa-fw text-primary text-base inline-block align-middle pr-3"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "tel:".concat(garage.phone),
                                        children: garage.phone
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center col-span-full md:mx-6 text-base leading-6 pt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "flex-grow garageListItem__brandIcons__garageText",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-kit fa-phone fa-fw text-primary text-base inline-block align-middle pr-3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(garage.phone),
                                    children: garage.phone
                                })
                            ]
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-12 flex px-4 text-base leading-6 font-semibold",
                children: [
                    ((ref3 = garage.pivot) === null || ref3 === void 0 ? void 0 : ref3.bookable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: availableDay ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                GarageListPopup_formatShortDate(garage.available_days[0].available_at),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                    id: getFormattedText(getDaysLeft(availableDay)),
                                    days: getDaysLeft(availableDay)
                                })
                            ]
                        }) : "n/a"
                    }),
                    partner.shouldDisplayPrize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex-grow text-right",
                        children: [
                            "€ ",
                            garage.calculation && garage.calculation.estimated_price > 0 ? garage.calculation.estimated_price.toFixed(2) : "vor Ort"
                        ]
                    })
                ]
            })
        ]
    });
});
GarageListPopup.displayName = "GarageListPopup";
/* harmony default export */ var Map_GarageListPopup = (GarageListPopup);

// EXTERNAL MODULE: ./public/assets/images/google.png
var google = __webpack_require__(4357);
;// CONCATENATED MODULE: ./components/GarageList/Map/GarageListMap.tsx









var GarageListMap = function(props) {
    var ref = (0,react.useState)(null), map = ref[0], setMap = ref[1];
    var ref1 = (0,react.useState)(null), selectedGarage = ref1[0], setSelectedGarage = ref1[1];
    var selectMarker = (0,react.useCallback)(function(garage, open) {
        if (open) {
            setSelectedGarage(garage);
            return;
        }
        setSelectedGarage(null);
    }, []);
    (0,react.useEffect)(function() {
        if (props.center.lat !== 0 && props.center.lon !== 0) {
            map === null || map === void 0 ? void 0 : map.setView([
                props.center.lat,
                props.center.lon
            ], props.center.name === "Deutschland" ? 6 : 11, {
                animate: true
            });
        }
    }, [
        props.garages,
        props.center
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapContainer/* MapContainer */.h, {
            center: [
                props.center.lat,
                props.center.lon
            ],
            zoom: props.center.name === "Deutschland" ? 6 : 11,
            scrollWheelZoom: false,
            ref: function(map) {
                return setMap(map);
            },
            style: {
                "width": "100%",
                "height": "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TileLayer/* TileLayer */.I, {
                    subdomains: [
                        "mt0",
                        "mt1",
                        "mt2",
                        "mt3"
                    ],
                    maxZoom: 20,
                    attribution: '\xa9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                    url: "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=de"
                }),
                props.center.name !== "Deutschland" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker/* Marker */.J, {
                    position: [
                        props.center.lat,
                        props.center.lon
                    ],
                    icon: leaflet_src_default().divIcon({
                        html: (0,server_browser/* renderToStaticMarkup */.uS)(/*#__PURE__*/ (0,jsx_runtime.jsx)(MapLocationIcon, {}))
                    })
                }),
                props.garages.map(function(garage, iterator) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: garage.lat && garage.lon && garage.baseCity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker/* Marker */.J, {
                            position: [
                                garage.lat,
                                garage.lon
                            ],
                            riseOnHover: true,
                            icon: leaflet_src_default().divIcon({
                                html: (0,server_browser/* renderToStaticMarkup */.uS)(/*#__PURE__*/ (0,jsx_runtime.jsx)(GarageListMapMarker, {
                                    garage: garage,
                                    open: selectedGarage ? selectedGarage.id === garage.id : false,
                                    onToggle: selectMarker,
                                    lat: garage.lat,
                                    lng: garage.lon,
                                    onClick: props.onSelectGarage,
                                    partner: props.partner
                                }))
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup, {
                                className: "garageListMapMarker__overlay",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map_GarageListPopup, {
                                    garage: garage,
                                    partner: props.partner
                                })
                            })
                        }, garage.id)
                    }, iterator);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "copyright absolute bottom-2 left-2 z-[9999]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: google/* default.src */.Z.src,
                        alt: "Google"
                    })
                })
            ]
        })
    });
};
var MapLocationIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44.713",
        height: "53.615",
        viewBox: "0 0 44.713 53.615",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    x: "0",
                    y: "0",
                    width: "44.713",
                    height: "53.615",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0.161"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            operator: "in",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                transform: "translate(-14.776 -135.686)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "matrix(1, 0, 0, 1, 14.78, 135.69)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "data-name": "Pfad 167",
                        d: "M37.131,141.686a13.355,13.355,0,0,0-13.355,13.355c0,5.386,1.877,6.887,11.984,21.538a1.667,1.667,0,0,0,2.318.428,1.648,1.648,0,0,0,.428-.428c10.108-14.65,11.984-16.159,11.984-21.538a13.354,13.354,0,0,0-13.355-13.355h0m0,18.482a5.127,5.127,0,1,1,5.127-5.127,5.127,5.127,0,0,1-5.127,5.127",
                        transform: "translate(-14.78 -135.69)",
                        fill: "var(--color-primary)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Map_GarageListMap = (GarageListMap);


/***/ }),

/***/ 9377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useDaysLeft; }
/* harmony export */ });
var useDaysLeft = function() {
    var getDaysLeft = function(availableDay) {
        var targetDate = new Date(availableDay);
        return Math.ceil((targetDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
    };
    var getFormattedText = function(days) {
        if (days > 1) {
            return "in_x_days";
        } else if (days === 1) {
            return "tomorrow";
        } else if (days === 0) {
            return "today";
        } else {
            return "";
        }
    };
    return {
        getDaysLeft: getDaysLeft,
        getFormattedText: getFormattedText
    };
};


/***/ }),

/***/ 5729:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1410:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hb": function() { return /* binding */ createLeafletContext; },
/* harmony export */   "UO": function() { return /* binding */ LeafletProvider; },
/* harmony export */   "mE": function() { return /* binding */ useLeafletContext; },
/* harmony export */   "sj": function() { return /* binding */ extendContext; }
/* harmony export */ });
/* unused harmony exports CONTEXT_VERSION, LeafletContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const CONTEXT_VERSION = 1;
function createLeafletContext(map) {
    return Object.freeze({
        __version: CONTEXT_VERSION,
        map
    });
}
function extendContext(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const LeafletContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const LeafletProvider = LeafletContext.Provider;
function useLeafletContext() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LeafletContext);
    if (context == null) {
        throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    }
    return context;
}


/***/ }),

/***/ 7999:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ createElementHook; },
/* harmony export */   "O": function() { return /* binding */ createElementObject; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function createElementObject(instance, context, container) {
    return Object.freeze({
        instance,
        context,
        container
    });
}
function createElementHook(createElement, updateElement) {
    if (updateElement == null) {
        return function useImmutableLeafletElement(props, context) {
            const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
            if (!elementRef.current) elementRef.current = createElement(props, context);
            return elementRef;
        };
    }
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(props);
        const { instance  } = elementRef.current;
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}


/***/ }),

/***/ 1591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dW": function() { return /* binding */ createLayerComponent; },
  "SO": function() { return /* binding */ createOverlayComponent; },
  "Lf": function() { return /* binding */ createTileLayerComponent; }
});

// UNUSED EXPORTS: createControlComponent, createPathComponent

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/context.js
var lib_context = __webpack_require__(1410);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/component.js



function component_createContainerComponent(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance , context  } = useElement(props).current;
        (0,react.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ react.createElement(lib_context/* LeafletProvider */.UO, {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0,react.forwardRef)(ContainerComponent);
}
function createDivOverlayComponent(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0,react.useState)(false);
        const { instance  } = useElement(props, setOpen).current;
        (0,react.useImperativeHandle)(forwardedRef, ()=>instance);
        (0,react.useEffect)(function updateOverlay() {
            if (isOpen) {
                instance.update();
            }
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0,react_dom.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0,react.forwardRef)(OverlayComponent);
}
function component_createLeafComponent(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance  } = useElement(props).current;
        (0,react.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0,react.forwardRef)(LeafComponent);
}

// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/element.js
var lib_element = __webpack_require__(7999);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/attribution.js

function useAttribution(map, attribution) {
    const attributionRef = (0,react.useRef)(attribution);
    (0,react.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) {
                map.attributionControl.removeAttribution(attributionRef.current);
            }
            if (attribution != null) {
                map.attributionControl.addAttribution(attribution);
            }
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/events.js

function useEventHandlers(element, eventHandlers) {
    const eventHandlersRef = (0,react.useRef)();
    (0,react.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) {
            element.instance.on(eventHandlers);
        }
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) {
                element.instance.off(eventHandlersRef.current);
            }
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/pane.js
var pane = __webpack_require__(1802);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/layer.js





function useLayerLifecycle(element, context) {
    (0,react.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function createLayerHook(useElement) {
    return function useLayer(props) {
        const context = (0,lib_context/* useLeafletContext */.mE)();
        const elementRef = useElement((0,pane/* withPane */.q)(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLayerLifecycle(elementRef.current, context);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/div-overlay.js




function createDivOverlayHook(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0,lib_context/* useLeafletContext */.mE)();
        const elementRef = useElement((0,pane/* withPane */.q)(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/generic.js






function createControlComponent(createInstance) {
    function createElement(props, context) {
        return createElementObject(createInstance(props), context);
    }
    const useElement = createElementHook(createElement);
    const useControl = createControlHook(useElement);
    return createLeafComponent(useControl);
}
function createLayerComponent(createElement, updateElement) {
    const useElement = (0,lib_element/* createElementHook */.I)(createElement, updateElement);
    const useLayer = createLayerHook(useElement);
    return component_createContainerComponent(useLayer);
}
function createOverlayComponent(createElement, useLifecycle) {
    const useElement = (0,lib_element/* createElementHook */.I)(createElement);
    const useOverlay = createDivOverlayHook(useElement, useLifecycle);
    return createDivOverlayComponent(useOverlay);
}
function createPathComponent(createElement, updateElement) {
    const useElement = createElementHook(createElement, updateElement);
    const usePath = createPathHook(useElement);
    return createContainerComponent(usePath);
}
function createTileLayerComponent(createElement, updateElement) {
    const useElement = (0,lib_element/* createElementHook */.I)(createElement, updateElement);
    const useLayer = createLayerHook(useElement);
    return component_createLeafComponent(useLayer);
}


/***/ }),

/***/ 1802:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ withPane; }
/* harmony export */ });
function withPane(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane
    } : props;
}


/***/ }),

/***/ 5715:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ MapContainer; }
/* harmony export */ });
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1410);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5243);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



function MapContainerComponent({ bounds , boundsOptions , center , children , className , id , placeholder , style , whenReady , zoom , ...options }, forwardedRef) {
    const [props] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        className,
        id,
        style
    });
    const [context, setContext] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new leaflet__WEBPACK_IMPORTED_MODULE_0__.Map(node, options);
            if (center != null && zoom != null) {
                map.setView(center, zoom);
            } else if (bounds != null) {
                map.fitBounds(bounds, boundsOptions);
            }
            if (whenReady != null) {
                map.whenReady(whenReady);
            }
            setContext((0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .createLeafletContext */ .Hb)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .LeafletProvider */ .UO, {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", _extends({}, props, {
        ref: mapRef
    }), contents);
}
const MapContainer = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(MapContainerComponent);


/***/ }),

/***/ 577:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Marker; }
/* harmony export */ });
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1591);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7999);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1410);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5243);


const Marker = (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_1__/* .createLayerComponent */ .dW)(function createMarker({ position , ...options }, ctx) {
    const marker = new leaflet__WEBPACK_IMPORTED_MODULE_0__.Marker(position, options);
    return (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .createElementObject */ .O)(marker, (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_3__/* .extendContext */ .sj)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) {
        marker.setLatLng(props.position);
    }
    if (props.icon != null && props.icon !== prevProps.icon) {
        marker.setIcon(props.icon);
    }
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) {
        marker.setZIndexOffset(props.zIndexOffset);
    }
    if (props.opacity != null && props.opacity !== prevProps.opacity) {
        marker.setOpacity(props.opacity);
    }
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) {
            marker.dragging.enable();
        } else {
            marker.dragging.disable();
        }
    }
});


/***/ }),

/***/ 2013:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ TileLayer; }
});

// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/generic.js + 5 modules
var generic = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/pane.js
var pane = __webpack_require__(1802);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/element.js
var lib_element = __webpack_require__(7999);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/grid-layer.js
function updateGridLayer(layer, props, prevProps) {
    const { opacity , zIndex  } = props;
    if (opacity != null && opacity !== prevProps.opacity) {
        layer.setOpacity(opacity);
    }
    if (zIndex != null && zIndex !== prevProps.zIndex) {
        layer.setZIndex(zIndex);
    }
}

// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(5243);
;// CONCATENATED MODULE: ./node_modules/react-leaflet/lib/TileLayer.js


const TileLayer = (0,generic/* createTileLayerComponent */.Lf)(function createTileLayer({ url , ...options }, context) {
    const layer = new leaflet_src.TileLayer(url, (0,pane/* withPane */.q)(options, context));
    return (0,lib_element/* createElementObject */.O)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    updateGridLayer(layer, props, prevProps);
    const { url  } = props;
    if (url != null && url !== prevProps.url) {
        layer.setUrl(url);
    }
});


/***/ })

}]);